module.exports = "<span data-ng-message=required>* Required</span> <span data-ng-message=pattern>* Only numbers with up to 2 decimals are allowed</span> ";